import Immutable from 'immutable';
import {
  OPEN_PAGE_SETTINGS_MODAL,
  CLOSE_PAGE_SETTINGS_MODAL,
  SAVE_PAGE_SETTINGS_START,
  UPDATE_DRAFT_COMMUNITY_OPTIONS,
  SAVE_PAGE_SETTINGS_SUCCESS,
  DELETE_PAGE_START,
  FETCH_ACCESS_SETTINGS_START,
  FETCH_ACCESS_SETTINGS_SUCCESS,
  FETCH_ACCESS_SETTINGS_FAILURE,
  UPDATE_ACCESS_SETTINGS,
  UPDATE_ACCESS_PERMISSIONS,
  FETCH_COHORT_SCHEDULING_OPTIONS_FAILURE,
  FETCH_COHORT_SCHEDULING_OPTIONS_START,
  FETCH_COHORT_SCHEDULING_OPTIONS_SUCCESS,
  UPDATE_DRAFT_COHORT_SCHEDULING_OPTIONS,
  FETCH_COMPLETION_OPTIONS_START,
  FETCH_COMPLETION_OPTIONS_SUCCESS,
  FETCH_COMPLETION_OPTIONS_FAILURE,
  UPDATE_DRAFT_COMPLETION_OPTIONS,
} from './actions';

// Assumption: we can only ever have one page settings modal open on a page
const DEFAULT_STATE = Immutable.fromJS({
  mountId: null,
  pagePath: null,
  pageId: null,
  isSaving: false,
  error: null,
  actionsDisabled: false,
  communityOptions: {
    // For the moment, since communityOptions are loaded by blockPageContent,
    // communityOptions.loading will never actually be true
    loading: false,
    changes: {},
  },
  accessSettings: {
    loading: false,
    error: null,
    data: {},
    changes: {},
  },
  cohortSchedulingOptions: {
    loading: false,
    error: null,
    data: {},
    changes: {},
  },
  completionOptions: {
    loading: false,
    error: null,
    data: {},
    changes: {},
  },
});

export function PageSettings(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case OPEN_PAGE_SETTINGS_MODAL: {
      const { pagePath, pageId, mountId } = action;
      return state.merge({
        pagePath,
        pageId,
        mountId,
      });
    }
    case SAVE_PAGE_SETTINGS_SUCCESS:
    case CLOSE_PAGE_SETTINGS_MODAL: {
      // reset everything
      return DEFAULT_STATE;
    }
    case SAVE_PAGE_SETTINGS_START: {
      return state.set('isSaving', true);
    }
    case DELETE_PAGE_START: {
      return state.set('actionsDisabled', true);
    }
    case UPDATE_DRAFT_COMMUNITY_OPTIONS: {
      const { changes } = action;
      return state.mergeIn(['communityOptions', 'changes'], changes);
    }
    case FETCH_ACCESS_SETTINGS_START: {
      return state.setIn(['accessSettings', 'loading'], true);
    }
    case FETCH_ACCESS_SETTINGS_SUCCESS: {
      const { data } = action;

      return state.mergeIn(['accessSettings'], {
        loading: false,
        error: null,
        data: Immutable.fromJS(data),
      });
    }
    case FETCH_ACCESS_SETTINGS_FAILURE: {
      return state.mergeIn(['accessSettings'], { loading: false, error: true });
    }
    case UPDATE_ACCESS_SETTINGS: {
      const { changes } = action;
      return state.mergeIn(['accessSettings', 'changes'], changes);
    }
    case UPDATE_ACCESS_PERMISSIONS: {
      const { permission, key, value } = action;

      if (permission === 'shared_with' && key === 'groups') {
        return state.setIn(
          ['accessSettings', 'changes', permission],
          Immutable.fromJS(value)
        );
      }

      return state.setIn(
        ['accessSettings', 'changes', permission, key],
        Immutable.fromJS(value)
      );
    }
    case FETCH_COHORT_SCHEDULING_OPTIONS_START: {
      return state.setIn(['cohortSchedulingOptions', 'loading'], true);
    }
    case FETCH_COHORT_SCHEDULING_OPTIONS_SUCCESS: {
      const { data } = action;
      return state.mergeIn(['cohortSchedulingOptions'], {
        loading: false,
        error: null,
        data: Immutable.fromJS(data),
      });
    }
    case FETCH_COHORT_SCHEDULING_OPTIONS_FAILURE: {
      return state.mergeIn(['cohortSchedulingOptions'], {
        loading: false,
        error: true,
      });
    }
    case UPDATE_DRAFT_COHORT_SCHEDULING_OPTIONS: {
      const { changes } = action;
      return state.mergeIn(['cohortSchedulingOptions', 'changes'], changes);
    }
    case FETCH_COMPLETION_OPTIONS_START: {
      return state.setIn(['completionOptions', 'loading'], true);
    }
    case FETCH_COMPLETION_OPTIONS_SUCCESS: {
      const { data } = action;
      return state.mergeIn(['completionOptions'], {
        loading: false,
        error: null,
        data: Immutable.fromJS(data),
      });
    }
    case FETCH_COMPLETION_OPTIONS_FAILURE: {
      return state.mergeIn(['completionOptions'], {
        loading: false,
        error: true,
      });
    }
    case UPDATE_DRAFT_COMPLETION_OPTIONS: {
      const { changes } = action;
      return state.mergeIn(['completionOptions', 'changes'], changes);
    }
    default: {
      return state;
    }
  }
}
